import TextOverlayMakeTextDynamicCard from './TextOverlayMakeTextDynamicCard';

export default TextOverlayMakeTextDynamicCard;
